import { useAppSelector, useAppTranslation } from "@/utils";
import copy from "copy-to-clipboard";
import { CopyOutlined, QrcodeOutlined } from "@payping/icons";
import { buildUrl } from "@payping/utilities-shared/url";
import { Button, Flex, LegacyCard, Popover, QRCode, Typography, message } from "@payping/web-components";
import { useRef } from "react";
import { downloadPersonalPageQrId, personalPageCopyId, personalPageLinkId } from "@/assets/googleTrackIds";
import { URLS } from "@payping/utilities-shared/consts";

const PersonalPageLink = () => {
  const { t } = useAppTranslation();
  const spanRef = useRef<HTMLSpanElement>(null);
  const username = useAppSelector((state) => state.user.personalInfo?.username);
  const personalPageUrl = buildUrl(URLS.PPNG_URL, username).toString();

  const handleCopyUrl = () => {
    const copied = copy(personalPageUrl);
    if (copied) message.success({ content: t("messages.copied") });
  };

  const qrCodeBase64Generator = () => {
    const canvas = spanRef.current?.querySelector<HTMLCanvasElement>("canvas");
    if (canvas) {
      return canvas.toDataURL();
    }
    return undefined;
  };

  const downloadQrCode = () => {
    const qrCodeBase64 = qrCodeBase64Generator();
    const image = new Image();
    const w = window.open("");

    if (qrCodeBase64 && w) {
      image.src = qrCodeBase64;
      w.document.write(image.outerHTML);
    }
  };

  if (!username) return null;

  return (
    <LegacyCard.Ant className="tw:w-full">
      <Flex vertical gap="8px" justify="center">
        <Typography.Title level={5}> {t("overview.personalPageLink.title")}</Typography.Title>
        <Flex align="center" gap="middle">
          {/* < لینک شخصی > */}
          <Typography.Link
            ellipsis
            rel={"noreferrer"}
            data-google-track={personalPageLinkId}
            href={personalPageUrl}
            target={"_blank"}
            className="en-font"
          >
            {personalPageUrl.replace("https://", "")}
          </Typography.Link>
          {/* < لینک شخصی /> */}

          {/* < کپی لینک > */}
          <Button
            title={t("copy")}
            type="text"
            onClick={() => {
              handleCopyUrl();
            }}
            icon={<CopyOutlined width={14} height={14} />}
            data-google-track={personalPageCopyId}
          />
          {/* < کپی لینک /> */}

          {/* < بارکد ایکن > */}
          <Popover
            content={
              <Flex vertical align="center">
                <span ref={spanRef}>
                  <QRCode size={128} bordered={false} value={personalPageUrl} rootClassName="tw:p-0!" />
                </span>
                <Button
                  block
                  type={"link"}
                  onClick={() => downloadQrCode()}
                  href={"#"}
                  data-google-track={downloadPersonalPageQrId}
                >
                  {t("download")}
                </Button>
              </Flex>
            }
            trigger={"hover"}
          >
            <Button icon={<QrcodeOutlined width={14} height={14} />} type="text" />
          </Popover>
          {/* < بارکد ایکن /> */}
        </Flex>
      </Flex>
    </LegacyCard.Ant>
  );
};

export default PersonalPageLink;
